import type { ColumnDef } from "@tanstack/react-table";
import { Match } from "@/api/tournaments";
import dayjs from "dayjs";
import { Checkbox } from "@/components/shadcn/checkbox";

export const matchColumns: ColumnDef<Match>[] = [
    {
        id: "select",
        header: "",
        cell: ({ row }) => (
            <div onClick={(e) => e.stopPropagation()}>
                <Checkbox
                    checked={row.getIsSelected()}
                    onCheckedChange={(value) => row.toggleSelected(!!value)}
                    aria-label="Select row"
                    className="ml-2 data-[state=checked]:bg-primary data-[state=checked]:border-primary cursor-pointer"
                />
            </div>
        ),
        enableSorting: false,
        enableHiding: false,
        size: 50,
    },
    {
        accessorKey: "date",
        header: "Date",
        cell: ({ row }) => dayjs(row.original.date).format("DD/MM/YYYY"),
    },
    {
        accessorKey: "awayTeam.shortName",
        header: "Away Team",
    },
    {
        accessorKey: "homeTeam.shortName",
        header: "Home Team",
    },
    {
        accessorKey: "score",
        header: "Score",
        cell: ({ row }) => `${row.original.awayGoals} - ${row.original.homeGoals}`,
        enableSorting: false,
    },
    {
        id: "matchId",
        header: "",
        cell: ({ row }) => <span className="text-[11px] text-on-surface-variant">{row.original.id}</span>,
        enableSorting: false,
        enableHiding: false,
        size: 0,
    },
];
